import styled, { css } from 'styled-components';
import Flag from 'components/Flag';
import { motion } from 'framer-motion';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Row = styled.div`
  flex-direction: column;
  display: flex;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 176px;

  @media ${sizes.tabletPortrait} {
    height: 176px;
  }
`;

export const Image = styled.img`
  width: 100%;
  position: relative;
  border-radius: 30px;
  transition: opacity 500ms;

  ${({ isBird }) =>
    isBird &&
    css`
      position: absolute;
      z-index: 0;
    `}

  ${({ hideOnScroll }) =>
    hideOnScroll &&
    css`
      opacity: 0;

      @media ${sizes.tabletPortrait} {
        opacity: initial;
      }
    `}

  @media ${sizes.tabletPortrait} {
    position: absolute;
    width: 176px;
    height: 176px;

    :hover {
      ${({ hideOnHover }) =>
        hideOnHover &&
        css`
          opacity: 0;
        `}
    }
  }
`;

export const sharedCloseXStyle = css`
  position: absolute;
  left: 12px;
  top: 4px;
  content: ' ';
  width: 2px;
  height: 16px;
  background-color: ${th('colors.white')};
`;

export const Close = styled.div`
  position: absolute;
  top: -10px;
  left: 188px;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background-color: ${th('colors.red')};
  cursor: pointer;

  ::before {
    ${sharedCloseXStyle};
    transform: rotate(-45deg);
  }
  ::after {
    ${sharedCloseXStyle};
    transform: rotate(45deg);
  }
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${sizes.tabletPortrait} {
    display: inline-flex;
    width: calc(100% - 176px - 28px);
    margin-left: 28px;
  }
`;

export const Name = styled.div`
  display: inline-block;
  font-size: 28px;
  margin-top: 12px;

  @media ${sizes.desktop} {
    font-size: 38px;
    line-height: 42px;
    white-space: pre-line;
    margin-top: 0px;
  }
`;

export const Title = styled.div`
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  padding-top: 6px;
  max-width: 90%;

  @media ${sizes.tabletPortrait} {
    padding-top: 16px;
  }
`;

export const ReadBio = styled.div`
  color: ${th('colors.turquoise')};
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  > svg {
    margin-left: 4px;
    transition: transform 200ms;

    ${({ showBio }) =>
      showBio &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const LocationRow = styled(Row)`
  margin: 15px 0 10px 0;

  @media ${sizes.tabletPortrait} {
    margin: 26px 0;
    align-items: center;
  }
`;

export const Location = styled.div`
  display: flex;
  font-size: 16px;
  color: ${th('colors.turquoise')};

  > span {
    max-width: 80%;
  }

  @media ${sizes.tabletPortrait} {
    color: ${th('colors.white')};

    > span {
      max-width: 320px;
    }
  }
`;

export const BioContainer = styled.div`
  > div {
    :first-child {
      margin-bottom: 16px;
    }

    @media ${sizes.tabletPortrait} {
      margin-bottom: 16px;
    }
  }

  @media ${sizes.desktop} {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;

    > div {
      width: 44%;

      :first-child {
        margin-right: 40px;
      }
    }
  }
`;

export const BioTitle = styled.div`
  font-weight: bold;
  margin-bottom: 6px;
  margin-top: 34px;
  color: ${th('colors.turquoise')};
`;

export const BioItem = styled.div`
  font-size: 16px;
  line-height: 29px;
  max-width: 530px; // TODO
  margin: 0;

  @media ${sizes.tabletPortrait} {
    :first-child {
      > ${BioTitle} {
        margin-top: 0;
      }
    }
  }
`;

export const StyledFlag = styled(Flag)`
  position: relative;
  bottom: -3px;
  margin-right: 7px;
`;

export const MediaIcons = styled.div`
  display: flex;
  margin-bottom: 14px;

  > svg {
    font-size: 28px;
    margin-right: 16px;
    margin-top: 34px;
    margin-bottom: 10px;
    opacity: 0.3;
    cursor: pointer;

    :hover {
      opacity: 1;
    }
  }

  @media ${sizes.tabletPortrait} {
    margin-bottom: 0;

    > svg {
      font-size: 22px;
    }
  }
`;

export const BackButton = styled.div`
  display: none;
  align-items: center;
  margin-right: auto;
  margin-top: 20px;
  color: ${th('colors.turquoise')};
  cursor: pointer;
  margin-bottom: 40px;

  :hover {
    color: #85e2e3;
  }

  > svg {
    margin-right: 10px;
  }

  @media ${sizes.tabletPortrait} {
    display: inline-flex;
  }
`;

export const MobileBio = styled(motion.div)`
  overflow: hidden;
`;
